/* global http */
const serviceFilterNews = {
	el: {
		body: document.body,
		mainContainer: document.querySelector('.js-filter-loadmore'),
		loadMoreButton: document.querySelector('.js-filter-loadmore-listener')
	},

	vars: {
		currentPage: 1
	},

	fxUpdatePagination() {

		// increase the current page
		this.vars.currentPage += 1

		// filter results on pagination selected
		this.fxFilterNews(this.el.mainContainer)
	},

	fxRenderCards(response, data) {
		if (response.status === 200) {

			//set variables for later use
			let cardsBetaGrid

			//then we need to render the new results looping through the data
			data.items.map(el => {

				//save card structure in a variable
				cardsBetaGrid =
					`
					<div class="cards-container__item">
						<a class="card-beta" href="${el.url}">
							<figure class="card-beta__figure">
								<img class="card-beta__image img-full" 
									src="${el.picture}" 
									alt="${el.title}">
							</figure>
							<div class="card-beta__content">
								<div class="card-beta__caption">
									<span class="card-beta__caption-lead">
										${el.date}
									</span>
								</div>
								<h2 class="card-beta__heading">
									${el.title}
								</h2>
							</div>
						</a>
					</div>
					`
				// insert wrap container inside container (cards-container__grid) that is already in the DOM
				document.querySelector('.cards-container__grid').insertAdjacentHTML('beforeend', cardsBetaGrid)

			})

			if (!data.loadMore) {
				this.el.loadMoreButton.style.display = 'none'
			}
		}
	},

	fxFilterNews(el) {
		// check if element exists
		if (!el) return

		// get endpoint
		const endpoint = el.getAttribute('data-action-loadmore')

		// get language that has to be sent to api
		const languageParameter = this.el.body.getAttribute('data-language')

		// set formData
		const formData = {
			page: this.vars.currentPage
		}

		// callback function 
		const callback = (response, data) => {
			// call function that will build cards
			this.fxRenderCards(response, data)
		}

		// call api
		http.fxPost(endpoint, formData, callback, languageParameter)
	},

	events() {
		// check if element exists
		if (!this.el.loadMoreButton) return

		// Responsible for pagination 
		this.el.loadMoreButton && this.el.loadMoreButton.addEventListener('click', () => this.fxUpdatePagination())

		// Responsible for filter on load page
		this.fxFilterNews(this.el.mainContainer)
	},

	init() {
		this.events()
	}
}

serviceFilterNews.init()